export default __webpack_public_path__ + "static/media/5.972fbf0b.png";